import Vue, { ref } from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
// import VueCompositionAPI, { ref } from '@vue/composition-api'

import i18n from '@/libs/i18n'
import Hotjar from '@hotjar/browser'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import '@/libs/vue-tel-input'

// Axios Mock Adapter
import '@/@fake-db/db'

// Periodic jobs
import '@/scripts/periodic_jobs'
import { isDemoHost } from '@core/utils/utils'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
// Vue.use(VueCompositionAPI)
Vue.$inProgressRequests = ref([])

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false
Vue.$trans = key => i18n.t(key)
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

if (process.env.NODE_ENV !== 'development') {
// Initialize hotjar
  const hotjarVersion = 6
  let siteId = 3704521
  try {
    if (isDemoHost()) {
      siteId = 3918225
    }
  } catch (e) {
    //
  }

  Hotjar.init(siteId, hotjarVersion)
  if (localStorage.storeId) {
    Hotjar.identify(localStorage.storeId, {})
  }
}
